var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViralMarketingSvgrepoCom1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4751 14.85C13.3391 14.85 14.8501 13.3389 14.8501 11.475C14.8501 9.61101 13.3391 8.09998 11.4751 8.09998C9.61114 8.09998 8.1001 9.61101 8.1001 11.475C8.1001 13.3389 9.61114 14.85 11.4751 14.85Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4751 45.9C13.3391 45.9 14.8501 44.389 14.8501 42.525C14.8501 40.6611 13.3391 39.15 11.4751 39.15C9.61114 39.15 8.1001 40.6611 8.1001 42.525C8.1001 44.389 9.61114 45.9 11.4751 45.9Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5249 45.9C44.3889 45.9 45.8999 44.389 45.8999 42.525C45.8999 40.6611 44.3889 39.15 42.5249 39.15C40.6609 39.15 39.1499 40.6611 39.1499 42.525C39.1499 44.389 40.6609 45.9 42.5249 45.9Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5249 14.85C44.3889 14.85 45.8999 13.3389 45.8999 11.475C45.8999 9.61101 44.3889 8.09998 42.5249 8.09998C40.6609 8.09998 39.1499 9.61101 39.1499 11.475C39.1499 13.3389 40.6609 14.85 42.5249 14.85Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0938 21.2625C18.7313 21.2625 16.875 23.2875 16.875 25.65C16.875 28.0125 18.7313 30.0375 21.0938 30.0375C24.8063 30.0375 28.5187 30.8812 31.8937 32.5687L35.2687 34.2562V24.4688V16.875L31.8937 18.5625C28.6875 20.25 24.975 21.2625 21.0938 21.2625Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5625 29.025L22.6125 37.125H26.8312V21.2625",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28125 39.9937C6.58125 36.2812 5.0625 31.8937 5.0625 27C5.0625 22.1062 6.58125 17.7187 9.28125 14.0062",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9938 44.7188C36.2813 47.4188 31.8938 48.9375 27.0001 48.9375C22.1063 48.9375 17.7188 47.4188 14.0063 44.7188",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8875 14.175C47.4188 17.7188 48.9375 22.275 48.9375 27C48.9375 31.8938 47.4188 36.2813 44.7188 39.9938",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0063 9.28125C17.7188 6.58125 22.1063 5.0625 27.0001 5.0625C31.8938 5.0625 36.2813 6.58125 39.9938 9.28125",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViralMarketingSvgrepoCom1);
export default __webpack_public_path__ + "static/media/viral-marketing-svgrepo-com 1.65625887c8331214e016f38b47f618e6.svg";
export { ForwardRef as ReactComponent };